import React, { useState } from 'react'
import { Box, Collapse, Link, Stack } from '@mui/material'
import DataRow from './DataRow'

type DetailLine = {
    label: string
    value: string
}

type Props = {
    lines: DetailLine[]
}

export default function DetailsDisclosure({ lines }: Props) {
    const [open, setOpen] = useState(false)
    if (!lines.length) return null
    return (
        <Box sx={{ mt: 1 }}>
            <Link
                component="button"
                type="button"
                variant="caption"
                underline="hover"
                onClick={() => setOpen((value) => !value)}
                sx={{ cursor: 'pointer', color: 'text.secondary' }}
            >
                {open ? 'Hide details' : 'Details'}
            </Link>
            <Collapse in={open}>
                <Stack spacing={0.5} sx={{ mt: 0.75 }}>
                    {lines.map((line) => (
                        <DataRow key={line.label} label={line.label} value={line.value} mono />
                    ))}
                </Stack>
            </Collapse>
        </Box>
    )
}
